import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const WrapperSlider = styled(Flex)`
  --height: 85px;
  display: inline-block;
  height: var(--height);
  overflow: hidden;
  position: relative;
  width: 100%;
  color: white;
  ${themeMediaQuery('below_sm')} {
    --height: 60px;
  }
`;

export const ContentSlider = styled(Text)`
  --height: 77px;

  @keyframes slideup {
    0% {
      top: 0;
    }
    8% {
      top: 0;
    }
    10% {
      top: calc(var(--height) * -1);
    }
    19% {
      top: calc(var(--height) * -1);
    }

    20% {
      top: calc(var(--height) * -2);
    }
    29% {
      top: calc(var(--height) * -2);
    }

    30% {
      top: calc(var(--height) * -3);
    }
    39% {
      top: calc(var(--height) * -3);
    }

    40% {
      top: calc(var(--height) * -4);
    }
    49% {
      top: calc(var(--height) * -4);
    }

    50% {
      top: calc(var(--height) * -5);
    }
    59% {
      top: calc(var(--height) * -5);
    }

    60% {
      top: calc(var(--height) * -6);
    }
    69% {
      top: calc(var(--height) * -6);
    }

    70% {
      top: calc(var(--height) * -7);
    }
    79% {
      top: calc(var(--height) * -7);
    }

    80% {
      top: calc(var(--height) * -8);
    }
    89% {
      top: calc(var(--height) * -8);
    }

    90% {
      top: calc(var(--height) * -9);
    }
    100% {
      top: calc(var(--height) * -9);
    }
  }

  display: block;
  width: 100%;
  position: absolute;
  text-align: center;
  line-height: var(--height);
  animation-name: slideup;
  animation-duration: 30s;
  animation-iteration-count: infinite;
  animation-timing-function: ease;

  ${themeMediaQuery('below_sm')} {
    --height: 60px;
  }

  ${themeMediaQuery('xl')} {
    --height: 88px;
  }
`;
